(function () {

  // guard against the script being included more than once (one <script>
  // tag per rendered modal on collection grids / rails)
  if (window.gmNotifyMeReady) return;
  window.gmNotifyMeReady = true;

  var KLAVIYO_BASE = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-notify-me]');
    if (!form) return;
    event.preventDefault();

    var message = form.querySelector('[data-notify-me-message]');
    if (!message) return;

    function show(text) {
      message.textContent = text;
      message.hidden = false;
    }
    var strings = window.notifyStrings || {};

    var key = form.dataset.klaviyoKey;
    var variantId = form.dataset.variantId;
    var emailInput = form.querySelector('input[name="email"]');
    var email = emailInput ? emailInput.value.trim() : '';

    if (form.dataset.notifyProvider !== 'klaviyo' || !key) {
      show(strings.notLive || 'Not available yet.');
      return;
    }
    if (!email || !variantId) {
      show(strings.error || 'Something went wrong.');
      return;
    }

    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;

    fetch(KLAVIYO_BASE + '?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: form.dataset.klaviyoRevision || '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: { type: 'profile', attributes: { email: email } }
            }
          },
          relationships: {
            variant: {

              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
            }
          }
        }
      })
    })
      .then(function (response) {
        if (response.ok) {
          show(strings.success || 'Thanks!');
          form.reset();
        } else {
          show(strings.error || 'Something went wrong.');
        }
      })
      .catch(function () {
        show(strings.error || 'Something went wrong.');
      })
      .finally(function () {
        if (submit) submit.disabled = false;
      });
  });
})();
